module.exports = __webpack_public_path__ + "static/media/daniel.3dedce2e.jpeg";